import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as toastr from 'toastr';

import pickListActions from './pickListActions';
import { Page, PageContent, PageHeader } from '../../components/common';
import PickListItemList from './PickListItemList';
import PickListTypeForm from './PickListTypeForm';

interface Props {
	actions: any;
	history: any;
	match: any;
	pickListType: PickListType;
	pickListItems: Array<PickListItem>;
}
interface State {
	isLoading: boolean;
}
class PickListItemListPage extends React.Component<Props, State> {
	state = {
		isLoading: false
	};

	componentDidMount() {
		this.props.actions.getPickListType(this.props.match.params.pickListTypeId);
	}

	savePickListType = () => {
		this.setState({ isLoading: true });
		this.props.actions
			.savePickListType(this.props.pickListType)
			.then(() => this.setState({ isLoading: false }))
			.then(() => toastr.success('PickList Type saved'));
	}
	onPickListItemEdit = (pickListItemId: string) => {
		this.props.history.push(`/admin/pick-lists/${this.props.match.params.pickListTypeId}/${pickListItemId}`);
	}
	onPickListItemDelete = (pickListItemId: string) => {
		toastr.error('NOT IMPLEMENTED');
	}

	typeInputChange = (e: any) => {
		const pickListType = {
			...this.props.pickListType,
			[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
		};

		this.props.actions.setPickListType(pickListType);
	}

	render() {
		const { pickListType, pickListItems } = this.props;
		const title = pickListType ? `${pickListType.description} items` : 'Pick list items';
		return (
			<Page title={`${pickListType.description} items`}>
				<PageContent>
					<PageHeader title={title} className="page-header-sm" />
					<div className="form-fieldset mb-4">
						<PickListTypeForm
							pickListType={pickListType}
							isLoading={this.state.isLoading}
							handleInputChange={this.typeInputChange}
							handleSaveClick={this.savePickListType}
						/>
					</div>
					<PickListItemList
						pickListItems={pickListItems}
						onEdit={this.onPickListItemEdit}
						onDelete={this.onPickListItemDelete}
					/>
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any, ownProps: any) {
	return {
		pickListType: state.pickList.type,
		pickListItems: state.pickList.items.filter(
			(i: PickListItem) => i.pickListTypeId === ownProps.match.params.pickListTypeId
		)
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...pickListActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(PickListItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/PickList/PickListItemListPage.tsx